
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

export default function Button({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  onClick, 
  className = '',
  disabled = false 
}: ButtonProps) {
  const baseClasses = 'font-gilroy font-semibold rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap hover:shadow-lg transform hover:-translate-y-1';
  
  const variants = {
    primary: 'bg-crop-black text-crop-white hover:bg-crop-dark',
    secondary: 'bg-crop-teal text-crop-black hover:bg-crop-teal/80',
    outline: 'border-2 border-crop-black text-crop-black hover:bg-crop-black hover:text-crop-white'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      {children}
    </button>
  );
}
